export default __webpack_public_path__ + "static/media/shell.731289fc.ogg";